import React, { useState } from "react";
import { useEffect } from "react";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import { Link, useNavigate } from "react-router-dom";
import NoContent from "../../../assets/vectors/NoContent.webp";
import { GetMyNotices } from "../../../services/NoticeService";
import { Box, Button, Checkbox, FormControlLabel } from "@mui/material";
import { GetCompanies } from "../../../services/CompanyService";
import { useSelector } from "react-redux";
import { getMyProfile } from "../../../features/profile/profileSlice";
import { Any } from "@grpc/grpc-js/build/src/generated/google/protobuf/Any";
import { GetRolesList } from "../../../services/RoleService";

const EditAccess = () => {
  const [data, setData] = useState([]);
  const myProfile = useSelector(getMyProfile);
  const navigate = useNavigate();

  useEffect(() => {
    GetDataAsync();
  }, []);

  const GetDataAsync = async () => {
    try {
      const data = await GetRolesList();
      console.log(data);

      setData(data.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const [checked, setChecked] = React.useState([true, false]);

  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, event.target.checked]);
  };

  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], event.target.checked]);
  };

  const children = (
    <Box sx={{ display: "flex", flexDirection: "column", mr: 3 }}>
      <FormControlLabel
        label="ایجاد آگهی"
        control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
      />
      <FormControlLabel
        label="ویرایش آگهی"
        control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
      />
    </Box>
  );

  return (
    <>
      <h6 className="mt-3">سطوح دسترسی کاربرارشد</h6>
      <hr />
      <div className="mt-1">
        <FormControlLabel
          label="آگهی"
          control={
            <Checkbox
              checked={checked[0] && checked[1]}
              indeterminate={checked[0] !== checked[1]}
              onChange={handleChange1}
            />
          }
        />
        {children}
      </div>
    </>
  );
};
export default EditAccess;
